import router from "../../router";
import media from "./media";
import Swal from "sweetalert2";
import axios from "axios";
let config = JSON.parse(localStorage.getItem("config"));

export default {
  namespaced: true,
  state: {
    data: [],
    pagination: {
      current: null,
      total: null,
      data: [],
    },
    single: false,
    activating: false,
    upload: {
      file: null,
      uploading: false,
      progress: 0,
    },
    uploader: {
      loading: false,
      data: [],
      file: null,
      uploading: false,
      progress: 0,
    },
    selectedVendor: null,
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.data = data;
    },
    SET_PAGINATION: (state, data) => {
      state.pagination = data;
    },
    SET_SINGLE: (state, data) => {
      state.single = data;
    },
    SET_SELECTED_VENDOR: (state, data) => {
      state.selectedVendor = data;
    },
    SET_BILLING_KEY: (state, key) => {
      if (state.single) {
        state.single.billingKey = key;
      }
    },
    SET_UPLOADING: (state, bool) => {
      state.upload.uploading = bool;
    },
    SET_FILE: (state, file) => {
      state.upload.file = file;
    },
    SET_UPLOAD_PROGRESS: (state, progress) => {
      state.upload.progress = progress;
    },
    SET_LOGO: (state, url) => {
      state.single.logo = url;
    },
    SET_ACTIVATING: (state, bool) => {
      state.activating = bool;
    },
    PUSH_NEW_LOCATION: (state, loc) => {
      state.single.locations.push(loc);
    },
    POP_LOCATION: (state, loc) => {
      state.single.locations = state.single.locations.filter((l) => {
        if (loc.id != l.id) {
          return l;
        }
      });
    },
  },
  actions: {
    all: function ({ commit, dispatch }) {
      commit("SET_LOADING_STATE", true, { root: true });
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get("vendors")
          .then((res) => {
            if (res.status == 200) {
              commit("SET_DATA", res.data.data);
              commit("SET_LOADING_STATE", false, { root: true });
              return resolve(res.data.data);
            }
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    search: function ({ commit, dispatch }, { searchWord }) {
      commit("SET_LOADING_STATE", true, { root: true });
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(`vendors?search=${searchWord}`)
          .then((res) => {
            if (res.status == 200) {
              commit("SET_LOADING_STATE", false, { root: true });
              return resolve(res.data.data);
            }
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    allWithoutLocs: function ({ commit, dispatch, state }, payload) {
      let url = "vendors?withoutLoc=true";
      if (payload) {
        if (payload.limit) {
          url = `${url}&limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
        if (payload.contactsOnly) {
          url = `${url}&contactsOnly=${payload.contactsOnly}`;
        }
        if (payload.vendorName) {
          url = `${url}&vendorName=${payload.vendorName}`;
        }
        if (payload.sortByDate) {
          url = `${url}&sortByDate=${payload.sortByDate}`;
        }
      }
      if (!payload || !payload.page) {
        commit("SET_LOADING_STATE", true, { root: true });
      }
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_DATA", res.data);
              }
              commit("SET_LOADING_STATE", false, { root: true });
              return resolve();
            }
            return resolve();
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    getSignedInVendors: function (_, payload) {
      return new Promise(function (resolve) {
        config = JSON.parse(localStorage.getItem("config"));
        axios
          .get(
            config.api +
              `/api/vendors?withoutLoc=true&limit=2&contactsOnly=true&sortByDate=true`,
            {
              headers: {
                Authorization: `Bearer ${payload.accessToken}`,
              },
            }
          )
          .then((res) => {
            if (res.status == 200) {
              return resolve(res.data.data);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    delete: function ({ commit, dispatch, state }, { id }) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`vendors/${id}`)
          .then((res) => {
            if (res.status == 200) {
              dispatch(
                "setSuccess",
                {
                  message: "Vendor Successfully Deleted",
                  title: "Success",
                },
                { root: true }
              );
              const newData = state.pagination.data.filter(
                (item) => item.id != id
              );
              commit("SET_PAGINATION", {
                total: state.pagination.total - 1,
                current: state.pagination.current,
                data: newData,
              });
              return resolve(true);
            } else {
              dispatch(
                "setError",
                {
                  message:
                    "Something went wrong. Please refresh the page and try again",
                  title: "Server Error",
                },
                { root: true }
              );
              return resolve(false);
            }
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    create: function ({ commit, dispatch }, data) {
      this.$http
        .post("vendors", data)
        .then((res) => {
          if (res.status == 200) {
            let id = res.data.data.id;
            commit("SET_SAVING_STATE", false, { root: true });
            router.push(`/vendors/${id}`);
          }
        })
        .catch((err) => {
          let error = "";
          if ((err.data || {}).data) {
            for (const item in err.data.data) {
              error += err.data.data[item];
              break;
            }
          } else {
            error = ((err || {}).data || {}).message;
          }
          dispatch(
            "setError",
            {
              message:
                error ||
                "Something went wrong. Please refresh the page and try again",
              title: "Error",
            },
            { root: true }
          );
        });
    },
    importVendors: function (_, data) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post("import-vendors", data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            resolve(err.data || err);
          });
      });
    },
    update: function ({ commit, dispatch }, vendor) {
      this.$http
        .put(`vendors/${vendor.id}`, {
          name: vendor.name,
          bio: vendor.bio,
          email: vendor.email,
          phone: vendor.phone,
          site: vendor.site,
          avatar_type: vendor.avatar_type,
          prevent_referrals: vendor.prevent_referrals,
          prevent_documents: vendor.prevent_documents,
          prevent_public_referrals: vendor.prevent_public_referrals,
          vendors_seen_only: vendor.vendors_seen_only,
          booking_link: vendor.booking_link,
        })
        .then((res) => {
          if (res.status == 200) {
            commit("SET_SAVING_STATE", false, { root: true });
            dispatch(
              "setSuccess",
              {
                message: "Vendor updated successfully",
                title: "Success",
              },
              { root: true }
            );
          }
        })
        .catch((err) => {
          dispatch(
            "setError",
            {
              message:
                ((err || {}).data || {}).message ||
                "Something went wrong. Maybe the email is used in another account",
              title: "Server Error",
            },
            { root: true }
          );
        });
    },
    get: function ({ commit, dispatch }, payload) {
      commit("SET_LOADING_STATE", true, { root: true });
      let vm = this;
      let url = `vendors/${payload.id}`;
      if (payload.forConnect) {
        url = `${url}?forConnect=${payload.forConnect}`;
      }
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              commit("SET_SINGLE", res.data.data);
              commit("SET_LOADING_STATE", false, { root: true });
              return resolve(res.data.data);
            }
            return resolve(false);
          })
          .catch((err) => {
            const message =
              ((err || {}).data || {}).message ||
              (((err || {}).data || {}).error || {}).message ||
              "Something went wrong. Please refresh the page and try again";
            dispatch(
              "setError",
              {
                message,
                title: "Server Error",
              },
              { root: true }
            );
            if (message.toLowerCase() == "access denied") {
              router.push(`/`);
            }
            return resolve(false);
          });
      });
    },
    getWithoutLoading: function ({ commit, dispatch }, id) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(`vendors/${id}`)
          .then((res) => {
            if (res.status == 200) {
              commit("SET_SINGLE", res.data.data);
              return resolve(true);
            }
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    toggleActivation: function ({ commit }, payload) {
      commit("SET_ACTIVATING", true);
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`vendors/${payload.vendor.id}/toggle-activation`)
          .then(() => {
            payload.vendor.active = payload.active ? false : true;
            commit("SET_ACTIVATING", false);
            return resolve(true);
          })
          .catch((err) => {
            Swal.fire({
              title: "Error",
              text: ((err.data || {}).error || err.error || {}).message,
              type: "error",
            });
            return resolve(false);
          });
      });
    },
    uploadProfileImage: function ({ commit, dispatch }, payload) {
      commit("SET_FILE", payload.file);
      commit("SET_UPLOADING", true);

      let formData = new FormData();
      formData.append("image", payload.file, payload.file.name);
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`vendors/${payload.vendor.id}/media/profile`, formData, {
            onUploadProgress: (uploadEvent) => {
              let progress = Math.round(
                (uploadEvent.loaded / uploadEvent.total) * 100
              );
              commit("SET_UPLOAD_PROGRESS", progress);
            },
          })
          .then((res) => {
            commit("SET_LOGO", res.data.data.name);
            commit("SET_FILE", null);
            commit("SET_UPLOADING", false);
            commit("SET_UPLOAD_PROGRESS", res.data.message);
            return resolve(true);
          })
          .catch(() => {
            commit("SET_FILE", null);
            commit("SET_UPLOADING", false);
            dispatch(
              "setError",
              {
                message: "Image size is too large, please use smaller one.",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    getRating: async function (_, id) {
      let res = await this.$http.get(`vendors/${id}/rating`);
      return res.data.data;
    },
    attachService: function ({ commit, dispatch }, data) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`vendors/${data.vendorId}/attach-service`, {
            service: data.serviceId,
          })
          .then((res) => {
            if (res.status == 200) {
              commit("SET_SAVING_STATE", false, { root: true });
              return resolve(true);
            }
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    detachService: function ({ commit, dispatch }, data) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`vendors/${data.vendorId}/detach-service`, {
            service: data.serviceId,
          })
          .then((res) => {
            if (res.status == 200) {
              commit("SET_SAVING_STATE", false, { root: true });
              return resolve(true);
            }
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    uploadIntakeForm: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        let formData = new FormData();
        formData.append("pdf", payload.file, payload.file.name);
        vm.$http
          .post(`vendors/${payload.vendor.id}/intake-form-pdf`, formData, {})
          .then(() => {
            return resolve();
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    removeIntakeForm: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`vendors/${payload.id}/intake-form-pdf`)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    setSelectedVendor: function ({ commit }, payload) {
      if (payload) {
        commit("SET_SELECTED_VENDOR", payload);
      }
    },
    clearVendorData: function ({ commit }) {
      commit("SET_SINGLE", false);
    },
  },
  modules: {
    media,
  },
};
